/**
 * A step's question, as the review asks it back.
 *
 * The editor marks the optional reflections "(optional)", which is a prompt to
 * a climber deciding whether to write anything. On the review they HAVE
 * decided, and the panel only renders at all when they wrote something — so
 * the word is answering a question nobody is asking any more, above an answer
 * that plainly exists.
 *
 * Stripped here rather than by giving every step two copies of its wording:
 * the review captions each answer with the question the climber was actually
 * asked, read from that step's own exported constant, and two constants per
 * step is exactly the drift that made them shared in the first place.
 */
export const reviewPrompt = (prompt: string): string =>
  prompt.replace(/\s*\((?:optional)\)\s*$/i, "");
